export enum MeetingLocationTypeKeys {
  physicalAddress = 'Physical Address',
  inboundCall = 'Inbound Call',
  outboundCall = 'Outbound Call',
  webConference = 'Web Conference',
  other = 'Other',
}
